// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64512fd7","455":"42969316","977":"826695ee"}[chunkId] + ".chunk.js";
};